export const isAcceptableFailure = statusCode => !statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;